import { createSlice } from '@reduxjs/toolkit';
import { clearReducers } from 'redux/logout';

export const initialState = {
  items: [],
  loaded: true,
  pageable: {
    pageSize: 10,
    pageNumber: 0,
    totalElements: 0,
  },
  marketplaceId: '',
  storeId: '',
  search: '',
  status: '',
  type: '',
  term: '',
  date: {
    from: '',
    to: '',
  },
  sort: '',
};

const packagesBySearchCode = createSlice({
  name: 'packages2',
  initialState,
  reducers: {
    fetchPackages: (state) => {
      state.loaded = false;
    },
    fetchPackagesSuccess: (state, action) => {
      state.items = action.payload.items;
      state.pageable.totalElements = action.payload.total;
      state.loaded = true;
    },
    fetchPackagesFailure: (state) => {
      state.loaded = true;
    },
    // Esto es porque PaquerSettingsButton puede (o no) modificar el estado del paquete. Se le delega la responsabilidad al sagas
    addPacket: () => {},
    updateDate: (state, action) => {
      state.date = action.payload;
      state.pageable.pageNumber = 0;
    },
    updateSearch: (state, action) => {
      state.pageable.pageNumber = 0;
      state.search = action.payload;
    },
    updatePackageType: (state, action) => {
      state.pageable.pageNumber = 0;
      state.type = action.payload;
    },
    updateDeliveryTerm: (state, action) => {
      state.pageable.pageNumber = 0;
      state.term = action.payload;
    },
    updateStatus: (state, action) => {
      state.status = action.payload;
      state.pageable.pageNumber = 0;
    },
    updateMarket: (state, action) => {
      state.pageable.pageNumber = 0;
      state.marketplaceId = action.payload;
    },
    updateStore: (state, action) => {
      state.pageable.pageNumber = 0;
      state.storeId = action.payload;
    },
    updatePaginationPackages: (state, action) => {
      state.pageable.pageNumber =
        action.payload.pageSize !== state.pageable.pageSize
          ? 0
          : action.payload.pageNumber;
      state.pageable.pageSize = action.payload.pageSize;
    },
    updateSortPackages: (state, action) => {
      state.loaded = false;
      state.sort = action.payload;
    },
    // Esto es porque components/paquerSelector utiliza este action en orden de editar el paquer y luego updatearlo con un PUT en paquerSettingsButton
    updatePackagePaquer: (state, action) => {
      const { packageId, selectedPaquer } = action.payload;
      const index = state.items.findIndex((item) => item.id === packageId);
      if (index > -1) {
        state.items[index].shippingScheduleDestination.driver = selectedPaquer;
      }
    },
    resetFilters: (state) => {
      state.search = initialState.search;
      state.date = initialState.date;
      state.pageable = initialState.pageable;
    },
    clearItems: (state) => {
      state.items = initialState.items;
    },
    refreshPage: () => {},
  },
  extraReducers: {
    [clearReducers]: () => initialState,
  },
});

export const { name, actions, reducer } = packagesBySearchCode;
